/**
 * BlockTypes are identifiers we can attach to blocks to indicate they have a specific purpose.
 * We can then run code specifically targeting these types of blocks.
 * */
export default {
    HERO: 'hero',
};
